import React from 'react';
import { Layout, Image } from 'antd';
import { Footer, Header, Content } from 'antd/es/layout/layout';
import logo from 'assets/images/farmers-plan-logo.svg';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'types';
import { useLocation } from 'react-router-dom';
import { LayoutIdentityHeader } from 'components/LayoutIdentityHeader';
import { OnboardingLayout } from 'components/OnboardingLayout';
import { AppSelectionHeaderProvider } from 'context/AppSelectionHeaderContext';
import { SectionNavigation, SECTION_NAVIGATION_PATHS } from 'components/SectionNavigation';

const ONBOARDING_PATHS = ['/register', '/validate', '/invite-validate', '/register-farm', '/farm-details', '/register-farm-summary', '/users'];
const IDENTITY_HEADER_PATHS = ['/app-selection'];


export function DefaultLayout({
  children,
}: {
  children: React.ReactNode;
}) {

  const { t }: TFunction = useTranslation();
  const location = useLocation();
  const isOnboarding = ONBOARDING_PATHS.includes(location.pathname);
  const isAppSelection = location.pathname === '/app-selection';
  const showSectionNavigation = SECTION_NAVIGATION_PATHS.includes(location.pathname);
  const showIdentityHeader = IDENTITY_HEADER_PATHS.includes(location.pathname);
  const showStandaloneSectionNavigation = showSectionNavigation && !showIdentityHeader;

  if (isOnboarding) {
    return <OnboardingLayout>{children}</OnboardingLayout>;
  }
  const appSelectionBackground =
    'radial-gradient(1200px 520px at 12% 0%, rgba(255, 214, 170, 0.55), rgba(255, 255, 255, 0) 60%), radial-gradient(1000px 520px at 88% 10%, rgba(196, 226, 255, 0.45), rgba(255, 255, 255, 0) 65%), linear-gradient(180deg, #f7f2ea 0%, #ffffff 70%)';

  return (
    <AppSelectionHeaderProvider>
    <Layout
      style={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: isAppSelection ? 'stretch' : 'center',
        background: isAppSelection ? appSelectionBackground : '#F9F9F9',
      }}
    >
      <Header
        style={{
          height: 'auto',
          padding: isAppSelection ? '24px 24px 8px' : undefined,
          alignContent: 'center',
          justifyContent: 'center',
          backgroundColor: isAppSelection ? 'transparent' : '#F9F9F9',
          textAlign: isAppSelection ? 'center' : undefined,
          width: isAppSelection ? '100%' : undefined,
          lineHeight: 'normal',
        }}
      >
        <div
          style={{
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
            }}
          >
            {showIdentityHeader ? (
              <LayoutIdentityHeader maxWidth={1440} sidePadding={0} showMenu={showSectionNavigation} />
            ) : (
              <Image
                src={logo}
                alt="Farmers Plan Logo"
                preview={false}
                style={{
                  marginTop: isAppSelection ? 0 : 40,
                  marginBottom: showStandaloneSectionNavigation ? 0 : 60,
                  width: 200,
                }}
              />
            )}
            {showStandaloneSectionNavigation ? <SectionNavigation /> : null}
          </div>
        </div>
      </Header>
      <Content
        style={{
          alignContent: 'center',
          justifyContent: 'center',
          width: isAppSelection ? '100%' : undefined,
        }}
      >
        {children}
      </Content>      
      <Footer
        style={{
          backgroundColor: isAppSelection ? 'transparent' : '#F9F9F9',
          textAlign: isAppSelection ? 'center' : undefined,
          width: isAppSelection ? '100%' : undefined,
        }}
      >
        <a href="https://www.farmersplan.com/villkor" target="_blank" rel="noreferrer">{t('TermsAndConditions')}</a>
      </Footer>
    </Layout>
    </AppSelectionHeaderProvider>
  );
}
